import classNames from 'classnames';

import AuthorInitials from '../typography/AuthorInitials';

import styles from '../../styles/partials/initials.module.css';

interface InitialsProps {
    name?: string | null;
    withoutCircle?: boolean;
    className?: string | null;
    initialsClassName?: string | null;
}

function Initials({
    name = null,
    withoutCircle = false,
    className = null,
    initialsClassName = null,
}: InitialsProps) {
    const initials =
        name !== null
            ? name
                  .split(' ')
                  .slice(0, 2)
                  .map((word) => (word !== null && word.length > 0 ? word[0] : ''))
                  .join('')
            : null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutCircle]: withoutCircle,
                },
                className,
            ])}
        >
            <div className={styles.circle}>
                <AuthorInitials className={classNames([styles.initials, initialsClassName])}>
                    {initials}
                </AuthorInitials>
            </div>
        </div>
    );
}

export default Initials;
